<template>
  <div class="box-summary-payment">
    <data-summary-payment
      v-if="Object.keys(dataResponse).length"
      :data-response="dataResponse"
      :products="products"
    />
    <div
      v-else-if="
        !$store.state.loaderDerek && Object.keys(dataResponse).length == 0
      "
      class="spinner-container"
    >
      <div class="spinner" />
    </div>
  </div>
</template>
<script>
import DataSummaryPayment from '@/components/Payment/DataSummaryPayment.vue'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'PedidoDetalle',
  components: { DataSummaryPayment },
  data() {
    return {
      dataResponse: null,
      products: [],
    }
  },
  computed: {
    ...mapState('', []),
    getDataProductsCRTO() {
      let arrayTemp = []
      this.dataResponse.productos.forEach(product => {
        arrayTemp.push({
          id: product.producto_sku,
          price: product.precio,
          quantity: 1,
        })
      })
      return arrayTemp
    },
  },
  async mounted() {
    this.changeMenu({ menu: 'menu-simple' })
    this.changeFooter({ footer: 'footer-simple' })
    this.$store.state.loaderDerek = true
    if (location.search) {
      await this.axios({
        method: 'GET',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/payment/payu/response' + location.search,
      })
        .then(response => {
          this.$store.state.loaderDerek = false
          if (response.data.response.carrito_cerrado == 0) {
            if (response.data.response.checkoutAnonimo == 1) {
              this.$router
                .replace({
                  name: 'PaymentAnonymous',
                  params: {
                    tokenCart: response.data.response.carrito.token,
                    transaccion_rechazada:
                      response.data.response.transaccion_rechazada,
                    showmodalPaymentDecline: true,
                  },
                })
                .catch(() => {})
            } else {
              this.$router
                .replace({
                  name: 'Payment',
                  params: {
                    showmodalPaymentDecline: true,
                    transaccion_rechazada:
                      response.data.response.transaccion_rechazada,
                  },
                })
                .catch(() => {})
            }
          } else {
            window.localStorage.removeItem('tokenCart')
            this.dataResponse = response.data.response.pedido
            this.products = response.data.response.pedido.productos
          }
        })
        .catch(() => {
          window.localStorage.removeItem('tokenCart')
          this.$store.state.loaderDerek = false
          this.$router.replace({ name: 'Home' }).catch(() => {})
        })
    } else {
      this.$router.push({ name: 'Home' })
    }
  },
  destroyed() {
    this.changeMenu({ menu: 'menu-base' })
    this.changeFooter({ footer: 'footer-derek' })
  },
  methods: {
    ...mapActions('layouts', ['changeMenu', 'changeFooter']),
    goToCuponPago() {
      location.href = this.dataResponse.linkTicketPago
    },
  },
}
</script>
<style scope>
.divider-product {
  height: 1px;
  background: #eaf0fc;
  margin-left: 1rem !important;
  max-width: 90% !important;
}
.sub-title {
  font-size: 18px;
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.spinner-container .spinner {
  z-index: 100;
  width: 70px;
  height: 70px;
  border: 4px solid var(--primary);
  border-right: 4px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
